export enum AccommodationType {
  Hotel = "Hotel",
  Apartment = "Apartment",
  CorporateApartment = "CorporateApartment",
  BedAndBreakfast = "BedAndBreakfast",
  Hostels = "Hostels",
  Guest = "Guest",
  StaffAccommodation = "StaffAccommodation"
}

export enum AccommodationRequestStatusType {
  Open = "Open",
  Closed = "Closed",
}
